import { make } from 'vuex-pathify';
import { DelinquencyPoolService } from '../services/delinquency-pool.service.js';
import Logger from '@/lib/logger.js';

const service = new DelinquencyPoolService();

const state = {
  delinquentLoans: []
};

const getters = {
  ...make.getters(state)
};

const mutations = make.mutations(state);

const actions = {
  async fetchDelinquentLoans({ commit }, payload) {
    try {
      const { data } = await service.fetchDelinquentLoans();
      commit('SET_DELINQUENT_LOANS', data);
    } catch (error) {
      Logger.error('Fetching Delinquent Loans')
      throw error
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
